import { useQuery } from "@tanstack/react-query";
import { getSegements } from "../../service/query/auth";

export const useGetSegements= () => {
  const segements = useQuery({
    queryKey:["SEGEMENTS"],
    queryFn:async()=> getSegements(),
    enabled: true,
    staleTime: 0,
  },

);
  return {data:segements?.data?.data,  ...segements,}
};